import { ref as x, computed as O, isRef as fe, isReactive as Je, isReadonly as We, reactive as ye, watch as Y, unref as E, nextTick as M, onUnmounted as qe, handleError as He } from "vue";
const P = {};
function zt(e = {}) {
  P.formatter = e;
}
function Vt(e) {
  P.translate = e;
}
function Ut() {
  P.dev = !0;
}
const pe = {
  "components.combobox.no_result": "Aucun résultat",
  "validations.required": "Valeur obligatoire",
  "validations.email": "Le format de l'adresse e-mail est incorrect",
  "validations.url": "l'url est invalide",
  "validations.file_max_size": "Le fichier sélectionné est trop grand. Maximum {size}",
  "validations.file_is_picture": "Le fichier sélectionné n'est pas une image. Format autorisé : {types}",
  "validations.caracters_unauthorized": "Seuls les caractères suivants sont autorisés : '{caracters}'",
  "validations.min_length": "Longueur minimum : {length}",
  "validations.max_length": "Longueur maximale : {length}",
  "validations.min_value": "La valeur minimale est {min}",
  "validations.max_value": "La valeur maximale est {max}",
  "validations.min_date": "La date doit être postérieure à {date_label}",
  "validations.max_date": "La date doit être antérieure à {date_label}",
  "validations.between_date": "La date ne peut être comprise qu'entre {min_label} et {max_label}"
};
let Fe;
function Kt(e) {
  Fe = e;
}
const B = {
  get formatter() {
    if (!P.formatter)
      throw new Error("configureFormatter");
    return P.formatter.timezone || (P.formatter.timezone = "Europe/Paris"), P.formatter.dateFormat || (P.formatter.dateFormat = "dd/MM/y"), P.formatter.timeFormat || (P.formatter.timeFormat = "HH:mm"), P.formatter.dateTimeFormat || (P.formatter.dateTimeFormat = "{{date}}, {{time}}"), P.formatter;
  },
  get translate() {
    return P.translate || (P.translate = (e, t = {}) => {
      const r = Object.keys(t);
      let n = e in pe ? pe[e] : e;
      for (const i of r)
        n = n.replace(`{${i}}`, t[i]);
      return n;
    }), P.translate;
  },
  get dev() {
    return P.dev;
  },
  get emitter() {
    return Fe;
  }
};
function R(e) {
  "@babel/helpers - typeof";
  return R = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, R(e);
}
function Ae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ge(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Ee(e, t, r) {
  return t && Ge(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Qe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Q(e, t);
}
function G(e) {
  return G = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, G(e);
}
function Q(e, t) {
  return Q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Q(e, t);
}
function De() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function H(e, t, r) {
  return De() ? H = Reflect.construct.bind() : H = function(i, o, s) {
    var l = [null];
    l.push.apply(l, o);
    var c = Function.bind.apply(i, l), f = new c();
    return s && Q(f, s.prototype), f;
  }, H.apply(null, arguments);
}
function Xe(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function de(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return de = function(n) {
    if (n === null || !Xe(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n)) return t.get(n);
      t.set(n, i);
    }
    function i() {
      return H(n, arguments, G(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Q(i, n);
  }, de(e);
}
function Ze(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function et(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ze(e);
}
function tt(e) {
  var t = De();
  return function() {
    var n = G(e), i;
    if (t) {
      var o = G(this).constructor;
      i = Reflect.construct(n, arguments, o);
    } else
      i = n.apply(this, arguments);
    return et(this, i);
  };
}
function rt(e) {
  return nt(e) || it(e) || Se(e) || at();
}
function nt(e) {
  if (Array.isArray(e)) return ve(e);
}
function it(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Se(e, t) {
  if (e) {
    if (typeof e == "string") return ve(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ve(e, t);
  }
}
function ve(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function at() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ot(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Se(e)) || t) {
      r && (e = r);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = !0, s = !1, l;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var c = r.next();
      return o = c.done, c;
    },
    e: function(c) {
      s = !0, l = c;
    },
    f: function() {
      try {
        !o && r.return != null && r.return();
      } finally {
        if (s) throw l;
      }
    }
  };
}
var I = Object.prototype.hasOwnProperty;
function K(e, t) {
  return e = e.slice(), e.push(t), e;
}
function he(e, t) {
  return t = t.slice(), t.unshift(e), t;
}
var ut = /* @__PURE__ */ function(e) {
  Qe(r, e);
  var t = tt(r);
  function r(n) {
    var i;
    return Ae(this, r), i = t.call(this, 'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)'), i.avoidNew = !0, i.value = n, i.name = "NewError", i;
  }
  return Ee(r);
}(/* @__PURE__ */ de(Error));
function m(e, t, r, n, i) {
  if (!(this instanceof m))
    try {
      return new m(e, t, r, n, i);
    } catch (c) {
      if (!c.avoidNew)
        throw c;
      return c.value;
    }
  typeof e == "string" && (i = n, n = r, r = t, t = e, e = null);
  var o = e && R(e) === "object";
  if (e = e || {}, this.json = e.json || r, this.path = e.path || t, this.resultType = e.resultType || "value", this.flatten = e.flatten || !1, this.wrap = I.call(e, "wrap") ? e.wrap : !0, this.sandbox = e.sandbox || {}, this.preventEval = e.preventEval || !1, this.parent = e.parent || null, this.parentProperty = e.parentProperty || null, this.callback = e.callback || n || null, this.otherTypeCallback = e.otherTypeCallback || i || function() {
    throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
  }, e.autostart !== !1) {
    var s = {
      path: o ? e.path : t
    };
    o ? "json" in e && (s.json = e.json) : s.json = r;
    var l = this.evaluate(s);
    if (!l || R(l) !== "object")
      throw new ut(l);
    return l;
  }
}
m.prototype.evaluate = function(e, t, r, n) {
  var i = this, o = this.parent, s = this.parentProperty, l = this.flatten, c = this.wrap;
  if (this.currResultType = this.resultType, this.currPreventEval = this.preventEval, this.currSandbox = this.sandbox, r = r || this.callback, this.currOtherTypeCallback = n || this.otherTypeCallback, t = t || this.json, e = e || this.path, e && R(e) === "object" && !Array.isArray(e)) {
    if (!e.path && e.path !== "")
      throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
    if (!I.call(e, "json"))
      throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
    var f = e;
    t = f.json, l = I.call(e, "flatten") ? e.flatten : l, this.currResultType = I.call(e, "resultType") ? e.resultType : this.currResultType, this.currSandbox = I.call(e, "sandbox") ? e.sandbox : this.currSandbox, c = I.call(e, "wrap") ? e.wrap : c, this.currPreventEval = I.call(e, "preventEval") ? e.preventEval : this.currPreventEval, r = I.call(e, "callback") ? e.callback : r, this.currOtherTypeCallback = I.call(e, "otherTypeCallback") ? e.otherTypeCallback : this.currOtherTypeCallback, o = I.call(e, "parent") ? e.parent : o, s = I.call(e, "parentProperty") ? e.parentProperty : s, e = e.path;
  }
  if (o = o || null, s = s || null, Array.isArray(e) && (e = m.toPathString(e)), !(!e && e !== "" || !t)) {
    var a = m.toPathArray(e);
    a[0] === "$" && a.length > 1 && a.shift(), this._hasParentSelector = null;
    var u = this._trace(a, t, ["$"], o, s, r).filter(function(d) {
      return d && !d.isParentSelector;
    });
    return u.length ? !c && u.length === 1 && !u[0].hasArrExpr ? this._getPreferredOutput(u[0]) : u.reduce(function(d, h) {
      var p = i._getPreferredOutput(h);
      return l && Array.isArray(p) ? d = d.concat(p) : d.push(p), d;
    }, []) : c ? [] : void 0;
  }
};
m.prototype._getPreferredOutput = function(e) {
  var t = this.currResultType;
  switch (t) {
    case "all": {
      var r = Array.isArray(e.path) ? e.path : m.toPathArray(e.path);
      return e.pointer = m.toPointer(r), e.path = typeof e.path == "string" ? e.path : m.toPathString(e.path), e;
    }
    case "value":
    case "parent":
    case "parentProperty":
      return e[t];
    case "path":
      return m.toPathString(e[t]);
    case "pointer":
      return m.toPointer(e.path);
    default:
      throw new TypeError("Unknown result type");
  }
};
m.prototype._handleCallback = function(e, t, r) {
  if (t) {
    var n = this._getPreferredOutput(e);
    e.path = typeof e.path == "string" ? e.path : m.toPathString(e.path), t(n, r, e);
  }
};
m.prototype._trace = function(e, t, r, n, i, o, s, l) {
  var c = this, f;
  if (!e.length)
    return f = {
      path: r,
      value: t,
      parent: n,
      parentProperty: i,
      hasArrExpr: s
    }, this._handleCallback(f, o, "value"), f;
  var a = e[0], u = e.slice(1), d = [];
  function h(F) {
    Array.isArray(F) ? F.forEach(function(ae) {
      d.push(ae);
    }) : d.push(F);
  }
  if ((typeof a != "string" || l) && t && I.call(t, a))
    h(this._trace(u, t[a], K(r, a), t, a, o, s));
  else if (a === "*")
    this._walk(t, function(F) {
      h(c._trace(u, t[F], K(r, F), t, F, o, !0, !0));
    });
  else if (a === "..")
    h(this._trace(u, t, r, n, i, o, s)), this._walk(t, function(F) {
      R(t[F]) === "object" && h(c._trace(e.slice(), t[F], K(r, F), t, F, o, !0));
    });
  else {
    if (a === "^")
      return this._hasParentSelector = !0, {
        path: r.slice(0, -1),
        expr: u,
        isParentSelector: !0
      };
    if (a === "~")
      return f = {
        path: K(r, a),
        value: i,
        parent: n,
        parentProperty: null
      }, this._handleCallback(f, o, "property"), f;
    if (a === "$")
      h(this._trace(u, t, r, null, null, o, s));
    else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(a))
      h(this._slice(a, u, t, r, n, i, o));
    else if (a.indexOf("?(") === 0) {
      if (this.currPreventEval)
        throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
      var p = a.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1");
      this._walk(t, function(F) {
        c._eval(p, t[F], F, r, n, i) && h(c._trace(u, t[F], K(r, F), t, F, o, !0));
      });
    } else if (a[0] === "(") {
      if (this.currPreventEval)
        throw new Error("Eval [(expr)] prevented in JSONPath expression.");
      h(this._trace(he(this._eval(a, t, r[r.length - 1], r.slice(0, -1), n, i), u), t, r, n, i, o, s));
    } else if (a[0] === "@") {
      var y = !1, v = a.slice(1, -2);
      switch (v) {
        case "scalar":
          (!t || !["object", "function"].includes(R(t))) && (y = !0);
          break;
        case "boolean":
        case "string":
        case "undefined":
        case "function":
          R(t) === v && (y = !0);
          break;
        case "integer":
          Number.isFinite(t) && !(t % 1) && (y = !0);
          break;
        case "number":
          Number.isFinite(t) && (y = !0);
          break;
        case "nonFinite":
          typeof t == "number" && !Number.isFinite(t) && (y = !0);
          break;
        case "object":
          t && R(t) === v && (y = !0);
          break;
        case "array":
          Array.isArray(t) && (y = !0);
          break;
        case "other":
          y = this.currOtherTypeCallback(t, r, n, i);
          break;
        case "null":
          t === null && (y = !0);
          break;
        default:
          throw new TypeError("Unknown value type " + v);
      }
      if (y)
        return f = {
          path: r,
          value: t,
          parent: n,
          parentProperty: i
        }, this._handleCallback(f, o, "value"), f;
    } else if (a[0] === "`" && t && I.call(t, a.slice(1))) {
      var b = a.slice(1);
      h(this._trace(u, t[b], K(r, b), t, b, o, s, !0));
    } else if (a.includes(",")) {
      var _ = a.split(","), w = ot(_), N;
      try {
        for (w.s(); !(N = w.n()).done; ) {
          var ie = N.value;
          h(this._trace(he(ie, u), t, r, n, i, o, !0));
        }
      } catch (F) {
        w.e(F);
      } finally {
        w.f();
      }
    } else !l && t && I.call(t, a) && h(this._trace(u, t[a], K(r, a), t, a, o, s, !0));
  }
  if (this._hasParentSelector)
    for (var k = 0; k < d.length; k++) {
      var z = d[k];
      if (z && z.isParentSelector) {
        var C = this._trace(z.expr, t, z.path, n, i, o, s);
        if (Array.isArray(C)) {
          d[k] = C[0];
          for (var V = C.length, U = 1; U < V; U++)
            k++, d.splice(k, 0, C[U]);
        } else
          d[k] = C;
      }
    }
  return d;
};
m.prototype._walk = function(e, t) {
  if (Array.isArray(e))
    for (var r = e.length, n = 0; n < r; n++)
      t(n);
  else e && R(e) === "object" && Object.keys(e).forEach(function(i) {
    t(i);
  });
};
m.prototype._slice = function(e, t, r, n, i, o, s) {
  if (Array.isArray(r)) {
    var l = r.length, c = e.split(":"), f = c[2] && Number.parseInt(c[2]) || 1, a = c[0] && Number.parseInt(c[0]) || 0, u = c[1] && Number.parseInt(c[1]) || l;
    a = a < 0 ? Math.max(0, a + l) : Math.min(l, a), u = u < 0 ? Math.max(0, u + l) : Math.min(l, u);
    for (var d = [], h = a; h < u; h += f) {
      var p = this._trace(he(h, t), r, n, i, o, s, !0);
      p.forEach(function(y) {
        d.push(y);
      });
    }
    return d;
  }
};
m.prototype._eval = function(e, t, r, n, i, o) {
  this.currSandbox._$_parentProperty = o, this.currSandbox._$_parent = i, this.currSandbox._$_property = r, this.currSandbox._$_root = this.json, this.currSandbox._$_v = t;
  var s = e.includes("@path");
  s && (this.currSandbox._$_path = m.toPathString(n.concat([r])));
  var l = "script:" + e;
  if (!m.cache[l]) {
    var c = e.replace(/@parentProperty/g, "_$_parentProperty").replace(/@parent/g, "_$_parent").replace(/@property/g, "_$_property").replace(/@root/g, "_$_root").replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1");
    s && (c = c.replace(/@path/g, "_$_path")), m.cache[l] = new this.vm.Script(c);
  }
  try {
    return m.cache[l].runInNewContext(this.currSandbox);
  } catch (f) {
    throw new Error("jsonPath: " + f.message + ": " + e);
  }
};
m.cache = {};
m.toPathString = function(e) {
  for (var t = e, r = t.length, n = "$", i = 1; i < r; i++)
    /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[i]) || (n += /^[\*0-9]+$/.test(t[i]) ? "[" + t[i] + "]" : "['" + t[i] + "']");
  return n;
};
m.toPointer = function(e) {
  for (var t = e, r = t.length, n = "", i = 1; i < r; i++)
    /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[i]) || (n += "/" + t[i].toString().replace(/~/g, "~0").replace(/\//g, "~1"));
  return n;
};
m.toPathArray = function(e) {
  var t = m.cache;
  if (t[e])
    return t[e].concat();
  var r = [], n = e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function(o, s) {
    return "[#" + (r.push(s) - 1) + "]";
  }).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function(o, s) {
    return "['" + s.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
  }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function(o, s) {
    return ";" + s.split("").join(";") + ";";
  }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, ""), i = n.split(";").map(function(o) {
    var s = o.match(/#([0-9]+)/);
    return !s || !s[1] ? o : r[s[1]];
  });
  return t[e] = i, t[e].concat();
};
var st = function(t, r, n) {
  for (var i = t.length, o = 0; o < i; o++) {
    var s = t[o];
    n(s) && r.push(t.splice(o--, 1)[0]);
  }
}, ct = /* @__PURE__ */ function() {
  function e(t) {
    Ae(this, e), this.code = t;
  }
  return Ee(e, [{
    key: "runInNewContext",
    value: function(r) {
      var n = this.code, i = Object.keys(r), o = [];
      st(i, o, function(a) {
        return typeof r[a] == "function";
      });
      var s = i.map(function(a, u) {
        return r[a];
      }), l = o.reduce(function(a, u) {
        var d = r[u].toString();
        return /function/.test(d) || (d = "function " + d), "var " + u + "=" + d + ";" + a;
      }, "");
      n = l + n, !/(["'])use strict\1/.test(n) && !i.includes("arguments") && (n = "var arguments = undefined;" + n), n = n.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      var c = n.lastIndexOf(";"), f = c > -1 ? n.slice(0, c + 1) + " return " + n.slice(c + 1) : " return " + n;
      return H(Function, i.concat([f])).apply(void 0, rt(s));
    }
  }]), e;
}();
m.prototype.vm = {
  Script: ct
};
let X;
function lt(e = {}) {
  const t = E(e), r = {}, n = {}, i = {};
  for (const o in t) {
    const s = t[o];
    if (s !== void 0)
      switch (!0) {
        case s.$external === !0:
        case typeof s.$validator == "function":
          r[o] = s;
          break;
        case typeof s == "function":
          r[o] = { $validator: s };
          break;
        case o.startsWith("$"):
          i[o] = s;
          break;
        default:
          n[o] = s;
      }
  }
  return {
    rules: r,
    nestedValidators: n,
    config: i
  };
}
function $e(e, t) {
  return t = Array.isArray(t) ? t : t.split("."), t.reduce(
    (r, n) => Array.isArray(r) ? r[parseInt(n)] : r[n],
    e
  );
}
function ft(e) {
  return "$external" in e && e.$external === !0;
}
function dt(e, t, r, n) {
  return e.call(
    {},
    E(r),
    {
      path: n,
      root: t,
      get parent() {
        if (n) return $e(E(t), n.split(".").slice(0, -1));
      },
      getParent(i) {
        if (i === null) return E(t);
        if (n) return $e(E(t), n.split(".").slice(0, i ? -i : void 0));
      }
    }
  );
}
function vt(e) {
  return typeof e == "boolean" ? !e : e.$valid !== void 0 ? !e.$valid : !e;
}
function ht(e, t, r, n, { $lazy: i }, o, s, l, c = []) {
  const f = x(!1);
  function a() {
    try {
      o.value = dt(e, t().$model, r, s.value), f.value = vt(o.value);
    } catch (v) {
      o.value = v, f.value = !0;
    }
    return f.value && (n.value = !0), !f.value;
  }
  function u() {
    const v = t();
    v && c.map((b) => b.replace("*.", "$each.*.")).map((b) => {
      const _ = m({ json: v, path: b });
      (Array.isArray(_) ? _ : [_]).forEach((N) => {
        N != null && N.$validate && (s.value === N.$path || s.value + "." + l === N.$path || N.$validate());
      });
    });
  }
  const d = () => {
    i && !n.value ? f.value = !1 : a();
  }, p = Y(r, () => {
    c.length && u(), d();
  });
  return Y(n, d), { $invalid: f, $unwatch: () => {
    p();
  }, $validate: a };
}
function me(e) {
  return Object.keys(e).reduce((t, r) => (t[r] = E(e[r]), t), {});
}
function yt(e, t, r, n, i, o, s, l) {
  const c = x(!1), f = e.$params || {}, a = x(null);
  let u, d, h;
  ft(e) ? (u = x(!1), d = () => {
  }, h = () => !u.value) : { $invalid: u, $unwatch: d, $validate: h } = ht(
    e.$validator,
    t,
    r,
    n,
    i,
    a,
    l,
    o,
    e.jsonQueries
  );
  const p = O(
    () => e.$message && typeof e.$message == "function" ? e.$message(
      me({
        $pending: c,
        $invalid: u,
        $params: me(f),
        // $params can hold refs, so we unref them for easy access
        $model: r,
        $response: a,
        $validator: o,
        $propertyPath: l,
        $property: s.value
      })
    ) : e.$message || ""
  ), y = x(l.value + "." + o);
  return {
    $message: p,
    $params: f,
    $pending: c,
    $invalid: u,
    $response: a,
    $unwatch: d,
    $validate: h,
    $path: y
  };
}
function ge(e, t, r, n, i, o) {
  const s = Object.keys(e), l = x(!1), c = {
    $dirty: l,
    $path: i.value,
    $touch: () => {
      l.value || (l.value = !0);
    },
    $reset: () => {
      l.value && (l.value = !1);
    }
  }, f = s.reduce((a, u) => (a[u] = yt(
    e[u],
    t,
    r,
    l,
    o,
    u,
    n,
    i
  ), a), {});
  return c.$invalid = O(
    () => s.some((a) => E(f[a].$invalid))
  ), c.$validate = () => s.map((a) => E(f[a]).$validate()).find((a) => a === !1) === void 0, c.$pending = O(
    () => s.some((a) => E(f[a].$pending))
  ), c.$error = O(
    () => c.$dirty.value ? c.$pending.value || c.$invalid.value : !1
  ), c.$silentErrors = O(
    () => s.filter((a) => E(f[a].$invalid)).map((a) => {
      const u = f[a];
      return ye({
        $propertyPath: i.value,
        $property: n.value,
        $validator: a,
        $uid: `${i.value}-${a}`,
        $message: E(u.$message),
        $params: u.$params,
        $response: u.$response,
        $pending: u.$pending
      });
    })
  ), c.$errors = O(() => c.$dirty.value ? c.$silentErrors.value : []), c.$unwatch = () => {
    s.forEach((a) => f[a].$unwatch());
  }, { ...c, ...f };
}
function pt(e, t) {
  const r = O({
    get() {
      return e.$dirty.value;
    },
    set(u) {
      e.$dirty.value = u;
    }
  }), n = O(() => r.value || t.value.some((u) => u.$dirty || u.$anyDirty)), i = O(() => {
    var d, h;
    const u = ((h = (d = e.$silentErrors) == null ? void 0 : d.value) == null ? void 0 : h.map(E)) || [];
    return t.value.map((p) => E(p.$silentErrors)).forEach((p) => {
      p && p.length && u.push(...p);
    }), u;
  }), o = O(() => n.value ? i.value : []), s = O({
    get() {
      return t.value.some((u) => u.$invalid) || // or if the current state is invalid
      E(e.$invalid) || // fallback to false if is root
      !1;
    },
    set(u) {
      e.$invalid && (e.$invalid.value = u);
    }
  }), l = O(
    () => (
      // if any of the nested values is pending
      t.value.some((u) => E(u.$pending)) || // if any of the current state validators is pending
      E(e.$pending) || // fallback to false if is root
      !1
    )
  ), c = O(() => r.value ? l.value || s.value : !1), f = (u = !0) => {
    e.$touch(), u && t.value.forEach((d) => d.$touch());
  }, a = () => {
    e.$reset(), t.value.forEach((u) => u.$reset());
  };
  return t.value.length && t.value.every((u) => u.$dirty) && f(), {
    $dirty: r,
    $errors: o,
    $invalid: s,
    $anyDirty: n,
    $error: c,
    $pending: l,
    $touch: f,
    $reset: a,
    $silentErrors: i
  };
}
function te({
  validations: e,
  parentState: t,
  getRoot: r,
  key: n,
  parentKey: i,
  globalConfig: o = {},
  skipGetRecord: s = !1,
  oldRecorded: l
}) {
  const c = O(() => i && i.value !== "" ? `${i.value}.${n.value}` : `${n.value}`), { rules: f, nestedValidators: a, config: u } = lt(e), d = { ...o, ...u }, h = n.value !== "" ? O(() => t.value ? t.value[n.value] : void 0) : t;
  let p;
  const y = {}, v = {}, b = x(l !== void 0 ? w(l) : null);
  let _ = null;
  function w($) {
    switch (typeof $) {
      case "string":
      case "bigint":
      case "boolean":
      case "number":
      case "undefined":
        return { val: $, isType: !1 };
      case "object":
        return { val: Array.isArray($) ? "array" : "object", isType: !0 };
      default:
        return { val: typeof $, isType: !0 };
    }
  }
  const N = ($ = !0, S = !0) => {
    if (b.value = w(h.value), $) {
      const g = (j) => {
        V.value.forEach((A) => A.$record(j, !1)), ue(), _ && (_ = v.$each.value.map((A) => A.$getRecord()));
      };
      S ? M(() => g($)) : g($);
    } else _ && (_ = v.$each.value.map((g) => g.$getRecord()));
  }, ie = ($, S = !1) => {
    if (b.value = w($), S && $)
      if (z) for (let g = 0; g < v.$each.value.length; g += 1)
        v.$each.value[g].$setRecord($[g], !0);
      else for (const g of Object.keys(y))
        y[g].$setRecord($[g], !0);
  }, k = ($) => {
    if (!b.value || s) return;
    let S;
    return b.value.isType && b.value.val === "object" ? S = V.value.reduce((g, j) => (j.$getRecord(g), g), {}) : b.value.isType && b.value.val === "array" ? S = _ : S = b.value.val, typeof $ == "object" && S != null && ($[n.value] = S), S;
  }, z = d.$isArray;
  delete d.$isArray;
  let C;
  if (z)
    p = ge({}, r, h, n, c, d), v.$each = x([]), _ = l !== void 0 ? l : [], C = Y(() => [...h.value || []], ($, S) => {
      if ($.length !== v.$each.value.length) {
        const g = [], j = [];
        if (S) {
          const A = S.map((L) => JSON.stringify(L)), T = $.map((L) => JSON.stringify(L));
          T.forEach((L, ce) => {
            const J = A.indexOf(L);
            J === -1 ? g.push(ce) : A.splice(J, 1);
          }), S.map((L) => JSON.stringify(L)).forEach((L, ce) => {
            const J = T.indexOf(L);
            J === -1 ? j.push(ce) : T.splice(J, 1);
          });
        } else
          g.push(...Array($.length).keys());
        for (const A of j.reverse()) {
          const T = v.$each.value.splice(A, 1)[0];
          T && T.$unwatch && T.$unwatch();
        }
        for (const A of g) {
          const T = te({
            validations: {
              ...a,
              ...f
            },
            parentState: h,
            getRoot: r,
            key: x(A),
            parentKey: c,
            globalConfig: d,
            oldRecorded: l !== void 0 ? l[A] : void 0
          });
          v.$each.value.splice(A, 0, T);
        }
        for (let A = 0; A < v.$each.value.length; A++) {
          const T = v.$each.value[A];
          A !== T.$key && (T.$key = A), T.$setRecord(_[A], !0), T.$invalid && T.$validate && T.$validate();
        }
      }
    }, { immediate: !0 }), y.length = te({
      validations: a.length,
      parentState: h,
      getRoot: r,
      key: x("length"),
      parentKey: c,
      globalConfig: d,
      skipGetRecord: !0,
      oldRecorded: l !== void 0 ? l.length : void 0
    });
  else {
    p = ge(f, r, h, n, c, d);
    for (const $ in a)
      y[$] = te({
        validations: a[$],
        parentState: h,
        getRoot: r,
        key: x($),
        parentKey: c,
        globalConfig: d,
        oldRecorded: l !== void 0 ? l[$] : void 0
      });
  }
  const V = O(
    () => Object.values(E(y)).concat(v.$each ? v.$each.value : [])
  ), {
    $dirty: U,
    $errors: F,
    $invalid: ae,
    $anyDirty: Be,
    $error: ze,
    $pending: Ve,
    $touch: oe,
    $reset: ue,
    $silentErrors: Ue
  } = pt(
    p,
    // Collect and merge this level validation results with all nested validation results
    V
  );
  function Ke() {
    return [
      p.$validate ? p.$validate() : !0,
      ...V.value.map(($) => $.$validate ? $.$validate() : !0)
    ].find(($) => $ === !1) === void 0;
  }
  let se;
  d.$autoDirty && (se = Y([h, b], ([$, S]) => {
    if (!S)
      ($ !== void 0 || $ !== null) && oe();
    else {
      let g = w($).val, j = S.val;
      (g === "" || Array.isArray(g) && g.length === 0) && (g = void 0), (j === "" || Array.isArray(j) && j.length === 0) && (j = void 0);
      const A = d.$autoDirtyCompare ? !d.$autoDirtyCompare(g, j) : g !== j;
      !U.value && A ? oe() : U.value && !A && ue();
    }
  }, { flush: "post", immediate: l !== void 0 }));
  function Ye() {
    p.$unwatch && p.$unwatch(), se && se(), C && C(), V.value.forEach(($) => {
      $.$unwatch && $.$unwatch();
    });
  }
  return ye({
    ...p,
    // NOTE: The order here is very important, since we want to override
    // some of the *results* meta fields with the collective version of it
    // that includes the results of nested state validation results
    $model: h,
    $dirty: U,
    $error: ze,
    $errors: F,
    $silentErrors: Ue,
    $invalid: ae,
    $anyDirty: Be,
    $pending: Ve,
    $touch: oe,
    $reset: ue,
    $record: N,
    $setRecord: ie,
    $getRecord: k,
    $validate: Ke,
    $key: n,
    $path: c,
    $unwatch: Ye,
    // add each nested property's state
    ...y,
    ...v
  });
}
function $t(e, t, r = {}) {
  const n = x({}), i = crypto.getRandomValues(new Uint32Array(1))[0];
  B.dev && !X && import("./vuelidate.dev-DBT9xUz0.js").then((f) => X = f.printDiff);
  const o = O(() => ({
    ...n.value,
    $uid: i,
    $printDiff: B.dev ? (f) => {
      X && X(n, t, f);
    } : void 0
  })), s = fe(e) || Je(e) || We(e), l = s ? { validations: e } : (
    // wrap plain objects in a reactive, so we can track changes if they have computed in them.
    { validations: ye(e || {}) }
  );
  let c = !1;
  return Y(l.validations, (f) => {
    let a;
    c && (n.value.$unwatch(), a = n.value.$getRecord()), n.value = te({
      validations: f,
      getRoot: () => o.value,
      parentState: t,
      key: x(""),
      globalConfig: r,
      oldRecorded: a
    }), !c && t.value && n.value.$record(), c = !0;
  }, {
    immediate: !0,
    deep: s
  }), o;
}
const mt = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i, gt = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/, Yt = function(t) {
  return new t();
}, ne = "validations.required", Pe = "validations.email", Oe = "validations.url", Te = "validations.file_max_size", xe = "validations.file_is_picture", je = "validations.caracters_unauthorized", Ie = "validations.min_length", Ne = "validations.max_length", Re = "validations.min_value", ke = "validations.max_value", Ce = "validations.min_date", Le = "validations.max_date", Me = "validations.between_date", bt = [
  ne,
  Pe,
  Oe,
  Te,
  xe,
  je,
  Ie,
  Ne,
  Re,
  ke,
  Ce,
  Le,
  Me
];
function D(e, t) {
  const r = typeof t == "object" ? t.i18nParams : void 0, n = typeof t == "object" ? t.jsonQueries : void 0;
  return typeof e == "function" && (e = { $validator: e }), e.$message = (i) => {
    let o = typeof t == "object" ? t.i18nKey : t;
    o = typeof o == "function" ? o(i) : o;
    const s = r === void 0 ? void 0 : typeof r != "function" ? r : r({
      model: i.$model,
      property: i.$property,
      pending: i.$pending,
      invalid: i.$invalid,
      response: i.$response,
      validator: i.$validator,
      propertyPath: i.$propertyPath,
      ...i.$params
    });
    return B.translate(o, s);
  }, n && (e.jsonQueries = n), r && (e.$params = r), e;
}
function _t(e, t) {
  return {
    $external: !0,
    $message: (r) => B.translate(
      typeof e == "function" ? e(r) : e,
      t ? typeof t == "function" ? t({
        model: r.$model,
        property: r.$property,
        pending: r.$pending,
        invalid: r.$invalid,
        response: r.$response,
        validator: r.$validator,
        propertyPath: r.$propertyPath,
        ...r.$params
      }) : t : {}
    )
  };
}
const wt = D((e) => {
  if (e = E(e), typeof e == "string" && (e = e.trim()), Array.isArray(e)) return !!e.length;
  if (e == null) return !1;
  if (e === !1) return !0;
  if (e instanceof Date) return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (const t in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, ne), Ft = D((e) => !!e || `${e}` != "0", ne), At = D((e) => e === void 0 || e === !0, ne), Et = D((e) => !e || mt.test(e), Pe), Dt = D((e) => !e || gt.test(e), Oe), St = D((e) => !(e instanceof File) || e.size < 1e6, { i18nKey: Te, i18nParams: { size: "1Mo" } }), Pt = D((e) => !(e instanceof File) || ["image/gif", "image/jpeg", "image/png"].indexOf(e.type) !== -1, { i18nKey: xe, i18nParams: { types: "gif, jpeg, png" } }), Ot = D((e) => !e || /^[0-9\-+() ]*$/.test(e), { i18nKey: je, i18nParams: { caracters: "+ ( ) - et les chiffres de 0 à 9" } }), Tt = (e, t = Ie) => D((r) => !r || r.length >= e, { i18nKey: t, i18nParams: { length: e } }), xt = (e, t = Ne) => D((r) => !r || r.length <= e, { i18nKey: t, i18nParams: { length: e } }), jt = (e, t = Re) => D((r) => r == null || +r >= +e, { i18nKey: t, i18nParams: { min: e } }), It = (e, t = ke) => D((r) => r == null || +r <= +e, { i18nKey: t, i18nParams: { max: e } }), Nt = (e, t, r = Ce) => D((n) => !n || n >= e, { i18nKey: r, i18nParams: t }), Rt = (e, t, r = Le) => D((n) => !n || n <= e, { i18nKey: r, i18nParams: t }), kt = (e, t, r, n = Me) => D((i) => !i || i >= e && i <= t, { i18nKey: n, i18nParams: r }), Ct = (e, t) => D((r) => e() === r, t), Lt = (e, t) => D((r) => !r || e.test(r), { i18nKey: t });
function Mt(e, t) {
  let r;
  return {
    $validator(n, i) {
      const o = e({ value: n, ...i });
      return typeof o == "object" ? (r = o.$message, t = o.$params || t) : typeof o == "string" && (r = o), !o;
    },
    $message() {
      if (r)
        return B.translate(r, t);
    }
  };
}
const Jt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  KEYS_ALL: bt,
  betweenDate: kt,
  email: Et,
  externalWithI18nMessage: _t,
  fileIsPicture: Pt,
  fileMaxSize1Mo: St,
  isTrue: At,
  maxDate: Rt,
  maxLength: xt,
  maxValue: It,
  minDate: Nt,
  minLength: Tt,
  minValue: jt,
  phone: Ot,
  regexp: Lt,
  required: wt,
  requiredNumber: Ft,
  sameAs: Ct,
  url: Dt,
  validate: Mt,
  withI18nMessage: D
}, Symbol.toStringTag, { value: "Module" }));
function Wt(e, t, r = {}) {
  const n = x(JSON.stringify(E(e), be)), i = fe(e) ? e : x(e), o = fe(t) ? t : x(t), s = $t(o, i, { $autoDirty: !0, $lazy: !0 }), l = B.emitter ? r.skipLockDirty ? null : B.emitter : null, c = () => Y(
    () => s.value.$anyDirty,
    (a, u) => {
      l && a !== u && (a ? l.dirty(s.value.$uid) : l.clean(s.value.$uid));
    }
  );
  let f = e === null ? null : c();
  return qe(() => {
    f && f(), l && l.clean(s.value.$uid);
  }), {
    refObj: i,
    validationObj: s,
    vArgs: o,
    /**
     * set value of refObj and save state to detect future changes.
     * @param obj optional set refObj. if undefined, use current val of refObj, refObj will therefore be considered as unmodified.
     */
    setVal(a) {
      return f === null && (f = c()), a !== void 0 && !(a instanceof Event) && (i.value = a), n.value = JSON.stringify(i.value, be), new Promise((u) => {
        M(() => {
          s.value.$record(), M(u);
        });
      });
    },
    /**
     * disard changes => reload stateStringify
     * @param force set the value to null temporarily, before reloading
     */
    resetVal(a = !1) {
      return a === !0 && (i.value = null), new Promise((u) => {
        M(() => {
          i.value = JSON.parse(n.value), s.value.$record(), M(() => {
            u();
          });
        });
      });
    }
  };
}
function be(e, t) {
  return t === "" ? void 0 : t;
}
function qt(e, t, r, n, i, o, s) {
  async function l() {
    if (i) {
      const c = await i();
      await n.setVal(c.values), o && o(c);
    }
  }
  return l(), {
    load: l,
    async sync(c) {
      const f = n.validationObj.value.$getRecord().map((y) => y.id);
      let a = 0, u = 0;
      const d = [], h = [], p = /* @__PURE__ */ new Map();
      for (const y of n.validationObj.value.$each) {
        const { id: v, ...b } = y.$model, _ = v ? f.findIndex((w) => w === v) : -1;
        if (_ !== -1 && f.splice(_, 1), v && v > 0)
          y.$anyDirty && (!c || c.some((w) => w === v) ? (await t(y.$model), h.push(v), y.$record()) : a++);
        else if (!c || c.some((w) => w === null)) {
          const w = await e(b);
          v && p.set(v, w.id), y.$record(), u++;
        } else
          a++;
      }
      for (const y of f)
        y && (!c || c.some((v) => v === y) ? (await r({ id: y }), d.push(y), u--) : a++);
      if (i && a === 0) {
        const y = await i();
        await n.setVal(y.values), s && s(y);
      } else u !== 0 && n.validationObj.value.length.$setRecord(
        n.validationObj.value.length.$getRecord() + u
      );
      return {
        /** map local id (< 0) to new id of created resource by api */
        getAddedId(y) {
          return p.get(y);
        },
        /** all new ids of created resources by api */
        get allAdded() {
          return [...p.values()];
        },
        get allDeleted() {
          return d;
        },
        get allUpdated() {
          return h;
        }
      };
    }
  };
}
const _e = "tx-button", Z = "data-vuelidate-invalid", ee = "data-vuelidate-unchanged", we = "data-vuelidate-clicking", W = /* @__PURE__ */ new Map(), q = {};
function re(e) {
  if (!e.value || typeof e.value != "function") {
    console.warn("vuelidate directive. wrong binding.value");
    return;
  }
  return e.value();
}
function le(e) {
  const t = re(e);
  if (!t) return;
  const { $invalid: r, $anyDirty: n, $uid: i } = Array.isArray(t.validation) ? t.validation.reduce(
    (o, s) => ({
      $invalid: o.$invalid || s.$invalid,
      $anyDirty: o.$anyDirty || s.$anyDirty,
      $uid: o.$uid + (s.$uid || 0)
    }),
    { $invalid: !1, $anyDirty: !1, $uid: 0 }
  ) : { $invalid: t.validation.$invalid, $anyDirty: t.validation.$anyDirty, $uid: t.validation.$uid };
  return { $invalid: r, $anyDirty: n, $uid: i, unchanged: t.unchanged, click: t.click };
}
const Ht = {
  beforeMount(e, t) {
    let r, n = !1, i = { $invalid: void 0, $anyDirty: void 0, unchanged: void 0 };
    const o = le(t), s = o != null && o.$uid ? o.$uid : (/* @__PURE__ */ new Date()).getTime();
    q[s] || (q[s] = { locked: !1 });
    const l = t.arg ? [t.arg] : [];
    if (e.classList.contains(_e)) {
      let f = function(u) {
        if (u) {
          if (i.$invalid && !u.$invalid) {
            const d = e.attributes.getNamedItem("title");
            d && (d.value = n && r ? r : "");
          }
          (i.$invalid !== u.$invalid || i.$anyDirty !== u.$anyDirty || i.unchanged !== u.unchanged) && (i = u, u.unchanged || (!u.$anyDirty && !e.getAttribute(ee) ? M(() => e.setAttribute(ee, "true")) : u.$anyDirty && e.getAttribute(ee) && M(() => e.removeAttribute(ee))), u.$invalid && !e.getAttribute(Z) ? M(() => e.setAttribute(Z, "true")) : !u.$invalid && e.getAttribute(Z) && M(() => e.removeAttribute(Z)));
        }
      };
      l.push("click"), q[s].button = e;
      const a = Y(() => le(t), f, { deep: !0 });
      if (W.set(e, { unwatch: a, uid: s }), f(o), B.dev) {
        let u;
        const d = function() {
          u && clearTimeout(u), u = void 0;
        };
        e.addEventListener("mousedown", () => {
          u = setTimeout(() => {
            const h = re(t), y = (h != null && h.validation ? Array.isArray(h.validation) ? h.validation : [h.validation] : []).filter((v) => v.$printDiff);
            y.length ? y.forEach((v, b) => v.$printDiff(b)) : console.log("no validation with $printDiff");
          }, 500);
        }), e.addEventListener("mouseup", d), e.addEventListener("mouseout", d);
      }
    } else if (e.localName === "form") {
      l.push("submit", "keyup.enter");
      const f = document.createElement("input");
      f.setAttribute("type", "submit"), f.setAttribute("hidden", ""), e.appendChild(f), e.setAttribute("novalidate", ""), e.setAttribute("action", ""), e.addEventListener("submit", (a) => a.preventDefault());
    }
    l.length || l.push("click");
    const c = async (f) => {
      var d, h;
      f.type === "submit" && await new Promise((p) => setTimeout(p, 500)), t.modifiers.prevent && f.preventDefault();
      const a = q[s];
      if (a != null && a.locked) return;
      a != null && a.button && a.button.setAttribute(we, "true");
      const u = (d = t.instance) == null ? void 0 : d.$;
      try {
        a.locked = !0;
        const p = re(t);
        if (!p) return;
        if (Array.isArray(p.validation) ? p.validation.map((v) => v.$validate()).find((v) => v === !1) === void 0 : p.validation.$validate())
          try {
            const v = le(t);
            v && !v.$invalid && (v.$anyDirty || v.unchanged) && await v.click();
          } catch (v) {
            u && He(v, u, 6);
          }
        else {
          const v = re(t);
          if (!v) return;
          if (p.onInvalid && p.onInvalid(), e.classList.contains(_e)) {
            const b = (Array.isArray(v.validation) ? v.validation : [v.validation]).map((_) => _.$silentErrors).flat(1);
            if (b) {
              let _ = e.attributes.getNamedItem("title");
              _ ? n || (n = !0, r = _.value) : (_ = document.createAttribute("title"), e.attributes.setNamedItem(_)), _.value = b.map((w) => w.$propertyPath ? `${w.$propertyPath}: ${w.$message}` : w.$message).join(`
`), (h = document.getElementById(`v-${b[0].$propertyPath}`)) == null || h.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        }
      } catch (p) {
        if (!u) throw p;
      } finally {
        a != null && a.button && a.button.removeAttribute(we), a != null && a.locked && (a.locked = !1);
      }
    };
    l.forEach((f) => e.addEventListener(f, c));
  },
  unmounted(e) {
    if (W.has(e)) {
      const t = W.get(e);
      t && (t.unwatch(), t.uid && [...W.values()].filter((r) => r.uid === t.uid).length === 1 && delete q[t.uid], W.delete(e));
    }
  }
};
export {
  Yt as N,
  Jt as a,
  Vt as b,
  zt as c,
  Kt as d,
  Ut as e,
  B as f,
  xt as g,
  Tt as m,
  wt as r,
  qt as s,
  Wt as u,
  Ht as v
};
//# sourceMappingURL=vuelidate-04GJpzoE.js.map
